import { AuthContext } from 'context/AuthContext';
import React, { useContext, useEffect } from 'react';
import { HeaderFilterService } from 'services/main';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { parseJwt } from 'utils/parse';
import * as Sentry from '@sentry/react';
const isValidObject = obj => {
  if (!obj) return false;

  const validate = value => {
    if (value === null || value === undefined || value === '') return false;

    if (typeof value === 'object' && !Array.isArray(value)) {
      return Object.values(value).every(validate);
    }

    return true;
  };

  return validate(obj);
};
const Amplifique = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { authContext } = useContext(AuthContext);
  const { user } = authContext;
  const email = `${user.id}@userleankeep.com`;
  const [cookie] = useCookies();

  useEffect(() => {
    if (pathname === '/login' || pathname === '/logout' || !cookie?.authToken || pathname.startsWith('/chamado-woba')) {
      return null;
    }
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      .amp-icon-cancel:before {
        display: block !important;
      }
    `;
    document.head.appendChild(styleTag);

    const loadScript = () => {
      return new Promise((resolve, reject) => {
        if (document.querySelector('script[src="https://cdn.amplifique.me/amplifiqueme-inapp-survey.js"]')) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.amplifique.me/amplifiqueme-inapp-survey.js';
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const initSurvey = async () => {
      try {
        const companyResponse = await HeaderFilterService.company(cookie?.companies?.id, cookie?.authToken);
        const companyType = companyResponse.data.tipoNome;

        const tokenPayload = parseJwt(cookie.authToken);
        const userTypeMap = {
          1: 'Super-Usuário',
          2: 'Administrador',
          3: 'Operacional',
          4: 'Chamado',
        };

        const userType = userTypeMap[Number(tokenPayload?.utyp)] || 'Desconhecido';
        const data = {
          email: email,
          created_at: user?.signUpUnixDate,
          name: user?.fullName,
          company: cookie?.companies?.name,
          custom_fields: {
            nome_empresa: cookie?.companies?.name,
            nome_usuario: user?.fullName,
            tipo_usuario: userType,
            segmento: companyType,
            idUsuario: user?.id,
            ehAdmin: user?.type === 'Operacional' ? 'True' : 'False',
            idEmpresa: String(cookie?.companies?.id),
            plataforma: 'Web-Novo',
            nomeEmpresa: cookie?.companies?.name,
            os: 'WEB',
          },
        };
        if (!isValidObject(data)) {
          Sentry.captureException(new Error('Amplifique survey data is not valid'), {
            extra: { data },
            tags: {
              feature: 'amplifique-survey',
              Empresa: cookie?.companies?.name,
            },
          });
          console.error('Amplifique survey data is not valid:', data);
          return;
        }
        await loadScript();

        window.Amplifiqueme = window.Amplifiqueme || {};
        window.Amplifiqueme.onLoad = () => {
          window.Amplifiqueme.identify(data, true);
        };

        const existingSurveyElement = document.querySelector('ampl-survey');
        if (!existingSurveyElement) {
          const amplSurveyElement = document.createElement('ampl-survey');
          amplSurveyElement.setAttribute('identifier', '64286cc685cacdbcf60441ac');
          //amplSurveyElement.setAttribute('force', 'true');
          //amplSurveyElement.setAttribute('debug', 'true');
          document.body.appendChild(amplSurveyElement);
        }
      } catch (error) {
        console.error('Error initializing Amplifique survey:', error);
        Sentry.captureException(new Error('Error initializing Amplifique survey:'), {
          tags: {
            feature: 'amplifique-survey',
            Empresa: cookie?.companies?.name,
          },
        });
      }
    };
    if (cookie?.companies?.id && user) {
      initSurvey();
    }

    return () => {
      const existingSurveyElement = document.querySelector('ampl-survey');
      if (existingSurveyElement && existingSurveyElement.parentNode) {
        existingSurveyElement.parentNode.removeChild(existingSurveyElement);
      }

      if (styleTag && styleTag.parentNode) {
        styleTag.parentNode.removeChild(styleTag);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, cookie?.authToken, pathname, cookie?.companies?.id]);

  return <div></div>;
};

export default Amplifique;
